import isEmpty from 'lodash/isEmpty';
import ProtoUtils from '../../../common/utilities/proto-utils';
import programs from '../../../programs';
import CurriculumUtils from './curriculum-utils';

const {
    Education: {
        GetDesiredCourseSummaryRequest,
        GetEducationServiceInfoRequest,
        RenderingClient,
        UserClient,
        UserActivityClient,
        GetVideoStatusRequest,
    },
    Google: {StringValue},
    Program: {ProgramType},
    getHeaders,
} = ProtoUtils;

const CurriculumAPI = {
    getCourse({activePrograms}) {
        if (isEmpty(activePrograms)) {
            return;
        }

        const surfacedProgram =
            CurriculumUtils.selectProgramToSurface(activePrograms);
        const preferredProgram = programs[surfacedProgram]?.dbSlug;
        const program = ProgramType.Values[preferredProgram];

        if (!program) {
            return;
        }

        const courseRequest = new GetDesiredCourseSummaryRequest();

        courseRequest.setProgram(program);
        courseRequest.setTimeZone(
            new StringValue().setValue(
                Intl.DateTimeFormat().resolvedOptions().timeZone
            )
        );

        return RenderingClient.getDesiredCourseSummary(
            courseRequest,
            getHeaders()
        );
    },
    getUrl({activePrograms}) {
        if (isEmpty(activePrograms)) {
            return;
        }

        const surfacedProgram =
            CurriculumUtils.selectProgramToSurface(activePrograms);
        const preferredProgram = programs[surfacedProgram]?.dbSlug;
        const program = ProgramType.Values[preferredProgram];

        if (!program) {
            return;
        }

        const serviceInfoRequest = new GetEducationServiceInfoRequest();

        serviceInfoRequest.setProgram(program);

        return UserClient.getEducationServiceInfo(
            serviceInfoRequest,
            getHeaders()
        );
    },

    getVideoWatchedStatus() {
        return UserActivityClient.getVideoStatus(
            new GetVideoStatusRequest(),
            getHeaders()
        ).then(response => response.getVideoStatusList());
    },
};

export default CurriculumAPI;
